import { z } from "zod"

export enum TaxSettingsStatus {
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
}

export const TaxSettingsStatusSchema = z.enum(TaxSettingsStatus).meta({ id: "TaxSettingsStatusSchema" })
